export default function ($routeSegmentProvider) {

  "ngInject";

  $routeSegmentProvider
    .when('/admin/users/admin/:id/info', 'admin.admin-user-info')
    .when('/admin/users/admin/:id/settings', 'admin.admin-user-settings')

    .within('admin')

    .segment('admin-user-info', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.users',
          url: '/admin/users'
        },
        {
          label: 'admin.breadcrumb.admin_info',
        }
      ],
      template: '<admin-info-profile-page></admin-info-profile-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-info-profile.module" */ "./admin-profile/admin-info-profile.module");
      }
    })

    .segment('admin-user-settings', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.users',
          url: '/admin/users'
        },
        {
          label: 'admin.breadcrumb.admin_info',
        }
      ],
      template: '<admin-info-security-page></admin-info-security-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-info-profile.module" */ "./admin-settings/admin-info-security.module");
      }
    })
}
